import * as React from "react";
import { BrManageContentButton, BrManageMenuButton } from "@bloomreach/react-sdk";
import { NewsletterBanner } from "@grandvisionhq/content";
import { Footer, FooterLinks } from "@grandvisionhq/layout";
import { useMeta } from "../../../../context/context/MetaContext.js";
import { getMenuItems } from "../../../../utils/utils/get-menu-items.js";
import { useBrPageContext, useBrComponentContext } from "../../../../context/context/context.js";
import { useBloomreachNewsletterData } from "../../../../hooks/hooks/use-bloomreach-newsletter-data.js";
import { useBloomreachNewsletterV2Data } from "../../../../hooks/hooks/use-bloomreach-newsletter-v2-data.js";
import { useBloomreachSiteLogos } from "../../../../hooks/hooks/use-bloomreach-site-logos.js";
const CmsFooter = ({ hasAlternativeLogo = true }) => {
  const { site } = useMeta();
  const siteLogos = useBloomreachSiteLogos();
  const page = useBrPageContext();
  const component = useBrComponentContext();
  const newsletterData = useBloomreachNewsletterData();
  const newsletterDataV2 = useBloomreachNewsletterV2Data();
  const preview = page?.isPreview();
  const siteName = site?.name ?? "Unknown";
  const fallbackLogo = hasAlternativeLogo ? siteLogos.alternative : siteLogos.main;
  const logoUrl = siteLogos.logoFooter || fallbackLogo;
  const logo = logoUrl ? {
    url: logoUrl,
    altText: siteName
  } : void 0;
  if (!page || !component) {
    return null;
  }
  const { document: documentRef } = component.getModels();
  const document = page.getContent(documentRef);
  const content = document?.getData();
  const { menuItems, menu } = getMenuItems("menu", component, page);
  const newsletterProps = {
    ...newsletterData,
    modalButtonTitle: content?.newsletterModal?.modalButtonTitle,
    isFullWidth: true
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, preview && document && /* @__PURE__ */ React.createElement("div", { style: { position: "relative" } }, /* @__PURE__ */ React.createElement(BrManageContentButton, { content: document })), content && /* @__PURE__ */ React.createElement(React.Fragment, null, newsletterDataV2 ? /* @__PURE__ */ React.createElement(NewsletterBanner, { ...newsletterDataV2 }) : null, /* @__PURE__ */ React.createElement(
    Footer,
    {
      ...content,
      logo,
      newsletterProps,
      hasNewsletterV2: !!newsletterDataV2,
      siteName
    },
    menuItems?.length > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, preview && menu && /* @__PURE__ */ React.createElement("div", { style: { position: "relative" } }, /* @__PURE__ */ React.createElement(BrManageMenuButton, { menu })), /* @__PURE__ */ React.createElement(FooterLinks, { items: menuItems }))
  )));
};
export {
  CmsFooter,
  CmsFooter as default
};
//# sourceMappingURL=Footer.js.map
